export var FETCH_SHIPPING_ADDRESSES_REQUEST = 'FETCH_SHIPPING_ADDRESSES_REQUEST';
export var FETCH_SHIPPING_ADDRESSES_SUCCESS = 'FETCH_SHIPPING_ADDRESSES_SUCCESS';
export var FETCH_SHIPPING_ADDRESSES_ERROR = 'FETCH_SHIPPING_ADDRESSES_ERROR';
export var FETCH_SHIPPING_ADDRESS_REQUEST = 'FETCH_SHIPPING_ADDRESS_REQUEST';
export var FETCH_SHIPPING_ADDRESS_SUCCESS = 'FETCH_SHIPPING_ADDRESS_SUCCESS';
export var FETCH_SHIPPING_ADDRESS_ERROR = 'FETCH_SHIPPING_ADDRESS_ERROR';
